/**
 * Created by luka on 23.02.2018.
 */

import {
    LOADING_REORDER_FAILED, REORDER_CORRUPTED,
    REORDER_LOADING, SUBMIT_ALREADY_MISSED,
} from "../actions/types";
export function loadingReorderFailed(state = false, action) {
    switch (action.type) {
        case LOADING_REORDER_FAILED:
            return action.error;
        default:
            return state;
    }
}
export function reorderLoading(state = false, action) {
    switch (action.type) {
        case REORDER_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function reorderCorrupted(state = false, action) {
    switch (action.type) {
        case REORDER_CORRUPTED:
            return action;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reorder/ReorderReducer.js